window.$ = window.jQuery = require('jquery');
// src/index.js
import '../../semantic/dist/components/dimmer';
import '../../semantic/dist/components/checkbox';
import '../../semantic/dist/components/transition';
import '../../semantic/dist/components/dropdown';
import '../../semantic/dist/components/modal';
import '../../semantic/dist/components/rating';
import '../../semantic/dist/components/tab';
import '../../semantic/dist/components/popup';
import '../../semantic/dist/components/sticky';
import '../../styles/sass/main.scss';
import 'react-datepicker/dist/react-datepicker.css';
window.Clipboard = require('clipboard');
import React from 'react';
import NavigationBar from './shared/navigation-bar/navigationBar';
import PubnubWarningMessage from 'containers/PubnubWarningMessage';
import GlobalMessage from './shared/global-message/globalMessage';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { renewAsOfNow } from '../actions/shared';
import GoogleAnalytics from 'react-ga';
import { getGoogleAnalyticsId } from '../actions/portalSetting';
import { mediaStyles, MediaContextProvider } from '../mediaSetting';

@connect(mapStateToProps)
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: props.loggedIn || false,
    };
  }

  UNSAFE_componentWillMount() {
    getGoogleAnalyticsId(this.initializeGoogleAnalytics);
  }
  //this is a call back function
  initializeGoogleAnalytics = (googleAnalyticsId) => {
    if (googleAnalyticsId) {
      window.APP.CONFIGURATION.GOOGLE_ANALYTICS_PROPERTY_ID = googleAnalyticsId; //so it can be used on other places as well
      GoogleAnalytics.initialize(googleAnalyticsId, {
        debug: !!window.APP.CONFIGURATION.DEBUG,
      });
      GoogleAnalytics.set({
        anonymizeIp: !!window.APP.CONFIGURATION.GOOGLE_ANALYTICS_ANONYMIZE_IP,
      });

      GoogleAnalytics.pageview(
        window.location.pathname,
        null,
        window.APP.CONFIGURATION.GOOGLE_ANALYTICS_PAGE_TITLE_MASK || window.document.title
      );

      // Feature detects Navigation Timing API support.
      if (window.performance) {
        // Gets the number of milliseconds since page load
        var timeSincePageLoad = Math.round(performance.now());
        console.log(`VCM App Loaded in ${timeSincePageLoad} ms`);

        // log the total to first meaningful render to Google Analytics
        GoogleAnalytics.timing({
          category: 'UI',
          variable: window.location.pathname,
          value: timeSincePageLoad, // in milliseconds
          label: 'App Loaded',
        });
      }
    }
  };
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ loggedIn: props.loggedIn });
  }

  componentDidMount() {
    this.props.dispatch(renewAsOfNow());
    this.interval = setInterval(() => this.props.dispatch(renewAsOfNow()), window.APP.ASOFNOW_INTERVAL || 30000);
  }

  componentWillUnmount() {
    console.log('clear interval in unmount for renewAsOfNow:', this.interval);
    clearInterval(this.interval);
  }

  render() {
    let navigationBar = '';
    let isUserOnVerifyEmailPage = window.location.href.toLowerCase().indexOf('verify-email') > -1;
    if (this.state.loggedIn) {
      navigationBar = <NavigationBar loggedInUser={this.state.loggedIn} />;
    }
    return (
      <div>
        <style>{mediaStyles}</style>
        <MediaContextProvider>
          <GlobalMessage />
          <audio id="soundNotification" />

          <PubnubWarningMessage dispatch={this.props.dispatch} />
          {isUserOnVerifyEmailPage || navigationBar}
          {this.props.children}
        </MediaContextProvider>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element,
};

function mapStateToProps(state) {
  return { loggedIn: state.usersReducer.loggedIn };
}
